module.exports = __webpack_public_path__ + "img/grid-3x3-gap.fbf66097.svg";